import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import { media } from "@atlaskit/primitives";

import { Adg4Button } from "@/components/adg4/button/src";
import { Picture } from "@/components/wpl/image/src";
import { Row } from "@/libraries/wpl/foundations/src";

export const Team24Promo = () => {
    const intl = useIntl();

    // Localized Strings
    const logoAltTxt = intl.formatMessage({
        id: "HomePageV2.Team24PromoSection.logoAltTxt",
        defaultMessage: "Atlassian team'24 event logo"
    });
    const promoDescription = intl.formatMessage({
        id: "HomePageV2.Team24PromoSection.description",
        defaultMessage:
            "Be the first to see our latest innovations. For a limited time only, save $1000 on your all-access pass."
    });
    const eventDates = intl.formatMessage({
        id: "HomePageV2.Team24PromoSection.eventDates",
        defaultMessage: "April 30 - May 2, 2024"
    });
    const eventLocations = intl.formatMessage({
        id: "HomePageV2.Team24PromoSection.eventLocations",
        defaultMessage: "Las Vegas and digitally"
    });
    const ctaTxt = intl.formatMessage({
        id: "HomePageV2.Team24PromoSection.ctaTxt",
        defaultMessage: "Register today"
    });

    // Styles
    const sectionStyle = css({
        marginInlineStart: "1rem",
        marginInlineEnd: "1rem"
    });

    const outerContainerStyle = css({
        background: "#E9F2FE",
        paddingBlockStart: "100px",
        paddingBlockEnd: "100px"
    });

    const innerContainerStyle = css({
        display: "grid",
        gridTemplateColumns: "1fr",

        [media.above.sm]: {
            gridTemplateColumns: "1.5fr 1fr"
        }
    });

    const wrapperLeftSide = css({
        "paddingInlineEnd": "2.2rem",

        ".logo-container": {
            maxWidth: "380px"
        },

        ".description": {
            maxWidth: "415px",
            paddingInlineStart: "7px"
        }
    });

    const wrapperRightSide = css({
        "position": "relative",
        "display": "flex",
        "flexDirection": "column",
        "justifyContent": "center",
        "gap": "24px",

        [media.above.sm]: {
            "paddingInlineStart": "2.2rem",
            "::after": {
                content: "",
                borderInlineStart: "2px solid #101214",
                height: "calc(100% - 10px)",
                position: "absolute",
                insetInlineStart: 0,
                insetBlockEnd: "5px"
            }
        },

        ".inline-container": {
            display: "flex",
            alignItems: "center"
        },
        "p": {
            margin: 0,
            paddingInlineStart: "1rem"
        },
        "button": {
            maxWidth: "189px"
        }
    });

    return (
        <section id="team-24-promo" css={sectionStyle}>
            <div className="outer-container" css={outerContainerStyle}>
                <Row layout="8">
                    <div className="inner-container" css={innerContainerStyle}>
                        <div className="wrapper-left" css={wrapperLeftSide}>
                            <div className="logo-container">
                                <Picture
                                    className="logo-desktop"
                                    image={{
                                        src: "//wac-cdn.atlassian.com/misc-assets/webp-images/team-24_attribution-logo-above-left_full-color_RGB.svg",
                                        alt: logoAltTxt
                                    }}
                                />
                            </div>
                            <p className="description">{promoDescription}</p>
                        </div>
                        <div className="wrapper-right" css={wrapperRightSide}>
                            <div className="inline-container">
                                <svg
                                    width="27"
                                    height="29"
                                    viewBox="0 0 27 29"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M2.3291 5.19287H24.8902V26.8054H2.3291V5.19287Z"
                                        stroke="#101214"
                                        strokeWidth="4"
                                        strokeLinejoin="round"
                                    />
                                    <path
                                        d="M26.8902 28.8057V13.6279H0.329102V28.8057H26.8902Z"
                                        fill="#101214"
                                    />
                                    <path
                                        d="M9.34082 9.83325V0.347141"
                                        stroke="#101214"
                                        strokeWidth="4"
                                        strokeLinejoin="round"
                                    />
                                    <path
                                        d="M17.8784 9.83325V0.347141"
                                        stroke="#101214"
                                        strokeWidth="4"
                                        strokeLinejoin="round"
                                    />
                                </svg>

                                <p>{eventDates}</p>
                            </div>
                            <div className="inline-container">
                                <svg
                                    width="27"
                                    height="29"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="9.68 0.78 19.96 27.51"
                                >
                                    <path
                                        d="M11.4599 16.396L19.6609 28.2876L27.862 16.396C32.4198 9.78722 27.689 0.777832 19.6609 0.777832C11.6329 0.777832 6.90209 9.78721 11.4599 16.396Z"
                                        fill="#101214"
                                    />
                                    <circle
                                        cx="19.661"
                                        cy="10.7382"
                                        r="4.74306"
                                        fill="#E9F2FE"
                                    />
                                </svg>
                                <p>{eventLocations}</p>
                            </div>
                            <Adg4Button
                                variant="secondary"
                                color="black"
                                size="medium"
                            >
                                {ctaTxt}
                            </Adg4Button>
                        </div>
                    </div>
                </Row>
            </div>
        </section>
    );
};
